import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "change-email" }
const _hoisted_2 = { class: "change-email__title" }
const _hoisted_3 = { class: "ds-caption ds-caption--bold ds-caption--size_3exl ds-caption--size_4xls-xl ds-caption--color_dark-blue" }
const _hoisted_4 = { class: "change-email__wrapper" }
const _hoisted_5 = { class: "email-change-form" }
const _hoisted_6 = { class: "email-change-form__label" }
const _hoisted_7 = { class: "ds-caption ds-caption--bold ds-caption--size_2md-xl ds-caption--color_black" }
const _hoisted_8 = { class: "email-change-form__input" }
const _hoisted_9 = { class: "error-label" }
const _hoisted_10 = {
  key: 0,
  class: "email-change-form__description"
}
const _hoisted_11 = { class: "ds-caption ds-caption--size_3xs ds-caption--size_2md-xl ds-caption--medium ds-caption--color_special-gray ds-caption--appearance_center" }
const _hoisted_12 = {
  key: 1,
  class: "email-change-form__confirm-input"
}
const _hoisted_13 = { class: "g-row g-row--space_lg g-row--justify_center g-row--align_center" }
const _hoisted_14 = { class: "g-cell g-cols g-cols--6" }
const _hoisted_15 = { class: "g-cell g-cols g-cols--6" }
const _hoisted_16 = { class: "hq-timer hq-timer--offset_none" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  class: "hq-timer__icon img",
  src: "/static/app/timer-icon.svg",
  alt: "timer icon",
  title: ""
}, null, -1)
const _hoisted_18 = { class: "hq-timer__time-wrapper" }
const _hoisted_19 = { class: "hq-timer__time" }
const _hoisted_20 = { class: "hq-timer__minutes" }
const _hoisted_21 = { class: "hq-timer__seconds" }
const _hoisted_22 = {
  key: 2,
  class: "email-change-form__description"
}
const _hoisted_23 = { class: "ds-caption ds-caption--size_3xs ds-caption--size_2md-xl ds-caption--medium ds-caption--color_special-gray ds-caption--appearance_center" }
const _hoisted_24 = { class: "email-change-form__btn" }
const _hoisted_25 = {
  key: 0,
  class: "hq-btn hq-btn--blue hq-btn--shadowed hq-btn--centered hq-btn--auth-style hq-btn--full_width hq-btn--full_height-xl",
  type: "submit"
}
const _hoisted_26 = { class: "hq-btn__text ds-caption ds-caption--color_white ds-caption--bold" }
const _hoisted_27 = { class: "email-change-form__btn" }
const _hoisted_28 = {
  key: 0,
  class: "hq-btn hq-btn--blue hq-btn--shadowed hq-btn--centered hq-btn--auth-style hq-btn--full_width hq-btn--full_height-xl",
  type: "submit"
}
const _hoisted_29 = { class: "hq-btn__text ds-caption ds-caption--color_white ds-caption--bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VeeError = _resolveComponent("VeeError")!
  const _component_d_control_input = _resolveComponent("d-control-input")!
  const _component_vue_countdown = _resolveComponent("vue-countdown")!
  const _component_vee_form = _resolveComponent("vee-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString($setup.$t("Смена e-mail")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_vee_form, {
        class: "hq-form",
        onSubmit: $setup.request
      }, {
        default: _withCtx(({ errors }) => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, _toDisplayString($setup.$t("E-mail")), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_VeeError, { name: "nonFieldErrors" }, {
                default: _withCtx(({ message }) => [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(message), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_d_control_input, {
                class: "input-main-gray",
                rules: "required|email",
                name: "token",
                "input-label": "",
                modelValue: $setup.email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.email) = $event))
              }, null, 8, ["modelValue"])
            ]),
            ($setup.activeTimer && !$setup.emailChanged || $setup.timeIsOver)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("p", _hoisted_11, _toDisplayString($setup.$t('На указанный вами e-mail был отправлен код подтверждения. Введите его в поле ниже для завершения смены.')), 1)
                ]))
              : _createCommentVNode("", true),
            ($setup.activeTimer && !$setup.emailChanged || $setup.timeIsOver)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_d_control_input, {
                        class: "input-main-gray",
                        rules: !$setup.timeIsOver? "required" : "",
                        name: "code",
                        "input-label": "",
                        modelValue: $setup.code,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.code) = $event))
                      }, null, 8, ["rules", "modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_vue_countdown, {
                            onEnd: _cache[2] || (_cache[2] = ($event: any) => ($setup.onCountdownEnd())),
                            time: 5 * 60 * 1000
                          }, {
                            default: _withCtx(({ minutes, seconds }) => [
                              _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, _toDisplayString($setup.formatter(minutes)) + _toDisplayString(":"), 1),
                                _createElementVNode("div", _hoisted_21, _toDisplayString($setup.formatter(seconds)), 1)
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            ($setup.emailChanged)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("p", _hoisted_23, _toDisplayString($setup.$t('E-mail  был успешно изменен!')), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_24, [
              (!$setup.timeIsOver)
                ? (_openBlock(), _createElementBlock("button", _hoisted_25, [
                    _createElementVNode("p", _hoisted_26, _toDisplayString($setup.activeTimer && !$setup.emailChanged ? $setup.$t("Подтвердить изменения") : $setup.$t("Сохранить изменения")), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_27, [
              ($setup.timeIsOver)
                ? (_openBlock(), _createElementBlock("button", _hoisted_28, [
                    _createElementVNode("p", _hoisted_29, _toDisplayString($setup.$t("Отправить код повторно")), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}